import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import { canonical, SITE_NAME } from '@/config/site'
import { homeMeta } from '@/data/homeContent'
import { CORE_PAGES, CORE_SUB_PAGES } from '@/data/corePages'
import { faqPageMeta } from '@/data/faqPage'
import { BLOG_POSTS } from '@/constants/blogPosts'
import { blogHubMeta } from '@/data/blogHubPage'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

function pageMeta(path, title, description, keywords, extra = {}) {
	return {
		appname: 'GB WhatsApp Pro',
		title,
		description,
		keywords,
		lang: 'en',
		link: [{ rel: 'canonical', href: canonical(path) }],
		...extra,
	}
}

const coreHubRoutes = Object.entries(CORE_PAGES).map(([pageKey, page]) => ({
	path: page.path,
	alias: page.path.replace(/\/$/, ''),
	name: `hub-${pageKey}`,
	meta: pageMeta(page.path, page.title, page.description, page.keywords, { pageKey }),
	component: () => import('@/views/coreHub.vue'),
}))

const blogPostRoutes = Object.entries(BLOG_POSTS).map(([blogId, post]) => ({
	path: `/${post.slug}/`,
	alias: `/${post.slug}`,
	name: post.slug,
	meta: pageMeta(`/${post.slug}/`, post.title, post.description, post.keywords, { blogId }),
	component: () => import('@/views/blogPost.vue'),
}))

const coreSubRoutes = Object.entries(CORE_SUB_PAGES).map(([subPageKey, page]) => ({
	path: page.path,
	alias: page.path.replace(/\/$/, ''),
	name: `sub-${subPageKey.replace(/\//g, '-')}`,
	meta: pageMeta(page.path, page.title, page.description, page.keywords, { subPageKey }),
	component: () => import('@/views/coreSubPage.vue'),
}))

export const constRoutesPc = [
	{
		path: '/',
		name: 'home',
		meta: pageMeta('/', homeMeta.title, homeMeta.description, homeMeta.keywords),
		component: Home,
	},
	{
		path: '/download/',
		alias: '/download',
		name: 'download',
		meta: pageMeta(
			'/download/',
			'Download GB WhatsApp Pro APK v18.80 for Android',
			'Download GB WhatsApp Pro APK with version details, install notes, and safety reminders for Android 5.0+.',
			'gb whatsapp pro apk download, gb whatsapp pro download',
		),
		component: () => import('@/views/download.vue'),
	},
	{ path: '/download-apk-page/', redirect: '/download/' },
	{ path: '/download-apk-page', redirect: '/download/' },
	{ path: '/old-versions/', redirect: '/update/check-version/' },
	{ path: '/old-versions', redirect: '/update/check-version/' },
	...coreHubRoutes,
	...coreSubRoutes,
	{
		path: '/faq/',
		alias: '/faq',
		name: 'faq',
		meta: pageMeta('/faq/', faqPageMeta.title, faqPageMeta.description, faqPageMeta.keywords),
		component: () => import('@/views/faqPage.vue'),
	},
	{
		path: '/blog/',
		alias: '/blog',
		name: 'blog',
		meta: pageMeta(
			'/blog/',
			blogHubMeta.title,
			blogHubMeta.description,
			blogHubMeta.keywords,
		),
		component: () => import('@/views/blogIndex.vue'),
	},
	...blogPostRoutes,
	{
		path: '/about/',
		alias: '/about',
		name: 'about',
		meta: pageMeta(
			'/about/',
			`About ${SITE_NAME}`,
			`Learn what ${SITE_NAME} is: an independent GB WhatsApp Pro information site, not affiliated with WhatsApp or Meta.`,
			'about gbwhatpro',
		),
		component: () => import('@/views/about.vue'),
	},
	{
		path: '/contact/',
		alias: '/contact',
		name: 'contact',
		meta: pageMeta(
			'/contact/',
			`Contact ${SITE_NAME}`,
			'Contact GBWhatPro.org for content corrections, privacy questions, or copyright notices.',
			'contact gbwhatpro',
		),
		component: () => import('@/views/contact.vue'),
	},
	{
		path: '/privacy-policy/',
		alias: '/privacy-policy',
		name: 'privacy-policy',
		meta: pageMeta(
			'/privacy-policy/',
			'Privacy Policy – GBWhatPro.org',
			'Privacy Policy for GBWhatPro.org explaining how we handle information on this independent help website.',
			'gbwhatpro privacy policy',
		),
		component: () => import('@/views/privacy.vue'),
	},
	{
		path: '/terms/',
		alias: '/terms',
		name: 'terms',
		meta: pageMeta(
			'/terms/',
			'Terms of Use – GBWhatPro.org',
			'Terms governing use of GBWhatPro.org content and download resources.',
			'gbwhatpro terms',
		),
		component: () => import('@/views/terms.vue'),
	},
	{ path: '/terms-of-service/', redirect: '/terms/' },
	{ path: '/terms-of-service', redirect: '/terms/' },
	{
		path: '/disclaimer/',
		alias: '/disclaimer',
		name: 'disclaimer',
		meta: pageMeta(
			'/disclaimer/',
			'Disclaimer – GBWhatPro.org',
			'Disclaimer about unofficial GB WhatsApp Pro software and independent site status.',
			'gbwhatpro disclaimer',
		),
		component: () => import('@/views/disclaimer.vue'),
	},
	{
		path: '/dmca/',
		alias: '/dmca',
		name: 'dmca',
		meta: pageMeta(
			'/dmca/',
			'DMCA – GBWhatPro.org',
			'How to submit copyright notices regarding content on GBWhatPro.org.',
			'gbwhatpro dmca',
		),
		component: () => import('@/views/dmca.vue'),
	},
	{
		path: '*',
		name: 'not-found',
		meta: pageMeta(
			'/404/',
			'Page Not Found – GBWhatPro.org',
			'This page does not exist on GBWhatPro.org. Return to the homepage or help center.',
			'gbwhatpro 404',
			{ noindex: true },
		),
		component: () => import('@/views/notFound.vue'),
	},
]

const routes = constRoutesPc

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) return savedPosition
			return { x: 0, y: 0 }
		},
	})
}
